import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	child__rules: 'mw/admin/child/rules',
	child__rule__add: 'mw/admin/child/rule/add',
	child__rule__del: 'mw/admin/child/rule/del',
};

export const childApi = createApi({
	reducerPath: 'mw/admin/childApi',

	endpoints: (builder) => ({
		childRules: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/child/rules?${qs.stringify(body)}`,
			}),
			providesTags: [tags.child__rules],
		}),
		childRuleAdd: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/child/rule/add',
				body,
				jsonType: true,
			}),
			providesTags: [tags.child__rule__add],
		}),
		childRuleDel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/child/rule/del',
				body,
				jsonType: true,
			}),
			providesTags: [tags.child__rule__del],
		}),
	}),
});

export const {
	childRules,
	childRuleAdd,
	childRuleDel,
} = childApi.endpoints;

export default childApi;